/*
 * Copyright (c) 2025-2026 Terra Technology (Guangzhou) Co., Ltd.
 * Copyright (c) 2024-2026 山东艾坦迪数智科技有限公司.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

export default {
  'component.globalHeader.search': 'جستجو ',
  'component.globalHeader.search.example1': 'مثال 1 را جستجو کنید',
  'component.globalHeader.search.example2': 'مثال 2 را جستجو کنید',
  'component.globalHeader.search.example3': 'مثال 3 را جستجو کنید',
  'component.globalHeader.help': 'کمک',
  'component.globalHeader.notification': 'اعلان',
  'component.globalHeader.notification.empty': 'شما همه اعلان ها را مشاهده کرده اید.',
  'component.globalHeader.message': 'پیام',
  'component.globalHeader.message.empty': 'شما همه پیام ها را مشاهده کرده اید.',
  'component.globalHeader.event': 'رویداد',
  'component.globalHeader.event.empty': 'شما همه رویدادها را مشاهده کرده اید.',
  'component.noticeIcon.clear': 'پاک کردن',
  'component.noticeIcon.cleared': 'پاک شد',
  'component.noticeIcon.empty': 'بدون اعلان',
  'component.noticeIcon.view-more': 'نمایش بیشتر',
};
